export const START_DATE_BUTTON_PLACEHOLDER_TEXT = 'Start';
export const END_DATE_BUTTON_PLACEHOLDER_TEXT = 'End';
export const START_DATE_BUTTON_ARIA_LABEL = 'Start Date';
export const END_DATE_BUTTON_ARIA_LABEL = 'End Date';
export const REQUIRED_MARK_ARIA_LABEL = 'Required';
export const SINGLE_DATE_PLACEHOLDER_TEXT = 'Date';
export const CALENDAR_ICON_ARIA_LABEL = 'Calendar Icon';
export const NEXT_ARROW_ICON_ARIA_LABEL = 'Next Arrow Icon';
